import React from 'react';
import PropTypes from 'prop-types';
import lodash from 'lodash';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';

class GRWaterDetailedBill extends React.Component {
  constructor(props) {
    super(props);
    const { bill, } = this.props;
    let { paymentTransactions, } = bill;
    const rows = [];
    const headers = [];

    if (paymentTransactions && paymentTransactions.length > 0 && JSON.parse(paymentTransactions).length > 0) {
      paymentTransactions = JSON.parse(bill.paymentTransactions);

      Object.keys(paymentTransactions[0]).forEach((key) => {
        headers.push({
          display: lodash.startCase(key),
          value: key,
        });
      });

      paymentTransactions.forEach((transaction) => {
        rows.push({
          value: Object.values(transaction),
          raw: transaction,
        });
      });
    }

    this.state = {
      transactionHeaders: headers,
      transactionRows: rows,
    };
    this.billExclusions = [ '$v', 'mongoId', ];
  }

  render() {
    const { bill, } = this.props;
    const { transactionHeaders = [], transactionRows = [], } = this.state;

    const formattedBill = ObjectUtils.clearNullValues(bill);

    const items = VerticalLabelList.toList(formattedBill, {
      displayFormatter: value => lodash.startCase(value.split('_').join('')),
    });

    return (
      <div>
        <FieldSet title="Bill Summary" style={{ maxHeight: '500px', }}>
          <VerticalLabelList items={items} exclusions={this.billExclusions} />
        </FieldSet>
        <FieldSet title="Bill Payments">
          <Grid
            headers={transactionHeaders}
            rows={transactionRows}
            onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            onRowSelect={() => {}}
          />
        </FieldSet>
      </div>
    );
  }
}

GRWaterDetailedBill.propTypes = {
  bill: PropTypes.instanceOf(Object).isRequired,
};

export default GRWaterDetailedBill;
